const interne = "Interne";
const offentlige = "Offentlige";
const filressurser = "Filressurser";

const interneLenker = [
  {
    tittel: "Skiltforskrifter - Power BI",
    link: "https://app.powerbi.com/groups/me/apps/9891af86-9be8-4f0b-a6ba-12ed7e6584ac/reports/2be27823-b2aa-4c58-b1b8-71da65a38754/5c642401670e97685e00?experience=power-bi",
    kategori: interne,
  },
  {
    tittel: "Midlertidige skiltvedtak, tidslinje - Power BI",
    link: "https://app.powerbi.com/groups/me/apps/9891af86-9be8-4f0b-a6ba-12ed7e6584ac/reports/2be27823-b2aa-4c58-b1b8-71da65a38754/dd482c9d0becf3647924?experience=power-bi",
    kategori: interne,
  },
  {
    tittel: "Parkeringer - Power BI",
    link: "https://app.powerbi.com/groups/me/apps/22edb600-16c2-4f00-a799-479c771a7ea3/reports/f3ce5d5e-a355-4d19-9c7c-2f2b94ea081f/c36945c855d90e800cc1?experience=power-bi",
    kategori: interne,
  },
  {
    tittel: "Driftstatus på tilkoblede systemer",
    link: "https://status.fiks.ks.no/",
    kategori: interne,
  },
  {
    tittel: "Innkreving - Pilen",
    link: "https://backoffice.cowisys.no/oslookf",
    kategori: interne,
  },
  {
    tittel: "Inntauingsløsning fra 01.12.2022",
    link: "https://inntauing.bymoslo.no/login",
    kategori: interne,
  },
  {
    tittel: "Geobank 2.0 - Matrikkelsøk Pro",
    link: "https://experience.arcgis.com/experience/025259a11b5446c4a16d096798b24ba2",
    kategori: interne,
  },
  {
    tittel: "Maintenance automatfeil/ladestolpefeil",
    link: "https://oslokommune.myview.cloud",
    kategori: interne,
  },
  {
    tittel: "STR Sak",
    link: "https://strsak.bymoslo.no/",
    kategori: interne,
  },
  {
    tittel: "Mobility WorkSpace (gammel, skal avvikles)",
    link: "https://pocketcontrol-hgk.oslo.kommune.no/",
    kategori: interne,
  },
  {
    tittel: "Mobility WorkSpace (ny)",
    link: "https://oslo-mws.giantleap.net/",
    kategori: interne,
  },
];

const offentligeLenker = [
  { tittel: "Lovdata", link: "https://lovdata.no/", kategori: offentlige },
  {
    tittel: "Google Maps",
    link: "https://www.google.no/maps/",
    kategori: offentlige,
  },
  {
    tittel: "Infotorg",
    link: "https://www.infotorg.no/",
    kategori: offentlige,
  },
  {
    tittel: "Bil i Oslo",
    link: "https://bilioslo.bymoslo.no/",
    kategori: interne,
  },
  {
    tittel: "Piggdekkoblat-Admin",
    link: "https://piggav.bymoslo.no/login",
    kategori: interne,
  },
  {
    tittel: "EasyPark",
    link: "https://dashboard.easypark.net/",
    kategori: interne,
  },
  {
    tittel: "Prinsippavgjørelser Parkeringsklagenemnda",
    link: "https://pklagenemnda.no/prinsippavgjorelser/",
    kategori: offentlige,
  },
  {
    tittel: "Kart over betalingsautomater",
    link: "https://experience.arcgis.com/experience/6d1ae07e9dc84e0793e661e743b6c5bc#widget_4=layer_visibility:%7B%22widget_4-dataSource_6%22%3A%7B%22widget_4-dataSource_6-19a5487faa9-layer-53-148883%22%3Afalse%2C%22widget_4-dataSource_6-19a5487faa9-layer-53-158103%22%3Afalse%2C%22widget_4-dataSource_6-19a5487faa9-layer-53-592033%22%3Afalse%2C%22widget_4-dataSource_6-19a5487faa9-layer-53-520870%22%3Afalse%2C%22widget_4-dataSource_6-19a5487faa9-layer-53-216219%22%3Afalse%2C%22widget_4-dataSource_6-19a5487faa9-layer-53-553160%22%3Afalse%2C%22widget_4-dataSource_6-19a5487faa9-layer-53-656328-190704%22%3Atrue%2C%22widget_4-dataSource_6-19a5487faa9-layer-53-656328-190704-408252%22%3Atrue%7D%7D,active_datasource_id:dataSource_6,center:596940.1977225408%2C6645291.31236521%2C25832,scale:20000,level:3,rotation:0,viewpoint:%7B%22rotation%22%3A0%2C%22scale%22%3A20000%2C%22targetGeometry%22%3A%7B%22spatialReference%22%3A%7B%22latestWkid%22%3A25832%2C%22wkid%22%3A25832%7D%2C%22x%22%3A596940.1977225408%2C%22y%22%3A6645291.31236521%7D%7D",
    kategori: offentlige,
  },
  {
    tittel: "Cale automat",
    link: "https://weboffice2.caleaccess.com/Cwo2/UserLogin.aspx",
    kategori: interne,
  },
  {
    tittel: "Enhetsregistret - Brønnøysundregistret",
    link: "https://w2.brreg.no/enhet/sok/",
    kategori: offentlige,
  },
  {
    tittel: "Svar Ut",
    link: "https://svarut.ks.no/",
    kategori: offentlige,
  },
  {
    tittel: "Folkeregistret",
    link: "https://forvaltning.fiks.ks.no",
    kategori: offentlige,
  },
];

const filressurserLenker = [
  {
    tittel: "Tverrfaglig - Sharepoint",
    link: `https://oslokommune.sharepoint.com/sites/13154/Tverrfaglig/Forms/AllItems.aspx`,
    kategori: filressurser,
  },
];

export { filressurserLenker, interneLenker, offentligeLenker };
